import React, { useState } from 'react';
import { db } from '../Components/auth/firebaseConfig'; // Importing Firestore database
import { query, where, getDocs } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { collection, addDoc } from 'firebase/firestore'; // Firestore methods for adding documents
import { Box, TextField, Button, Typography, Snackbar, Alert, MenuItem, Select, FormControl, InputLabel } from '@mui/material'; // MUI components for UI
import { useNavigate } from 'react-router-dom'; // Hook for navigation
import SideDrawer from '../Components/newcomponents/SideDrawer'; // Importing the SideDrawer component
import { getCookie } from '../utils/cookieUtils';

// Array of roles for user access permissions
const roles = [
  // { value: 'Super Admin', label: 'Super Admin' },
  { value: 'Admin', label: 'Admin' },
  // { value: 'Operator', label: 'Operator' },
  { value: 'Normal User', label: 'User' },
  // { value: 'Guest', label: 'Guest' },
];

const AddUserGroup = () => {
  // State to hold input values and error messages
  const [userGroupId, setUserGroupId] = useState(''); // User group ID input
  const [groupName, setGroupName] = useState(''); // Group name input
  const [accessPermission, setAccessPermission] = useState(roles[0].value); // Selected access permission, default to first role
  const [error, setError] = useState(null); // Error message state
  const [open, setOpen] = useState(false); // Snackbar open/close state
  const navigate = useNavigate(); // Navigation hook

  // Function to handle form submission
  const handleSubmit = async (event) => {
      event.preventDefault(); // Prevent default form submission behavior
      try {
        // Prefer tenant selected at login for multi-tenant users.
        const sessionUserData = getCookie('userData');
        let tenantId = sessionUserData?.tenantId || '';

        // Fallback if session cookie is unavailable.
        if (!tenantId) {
          const auth = getAuth();
          const currentUser = auth.currentUser;
          if (currentUser && currentUser.email) {
            const usersRef = collection(db, 'users');
            const q = query(usersRef, where('email', '==', currentUser.email));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
              const adminDoc = querySnapshot.docs[0];
              tenantId = adminDoc.data().tenantId || '';
            }
          }
        }

        if (!tenantId) {
          throw new Error('No tenant selected for current session');
        }

        // Add new user group to Firestore with admin's tenantId
        await addDoc(collection(db, 'userGroups'), {
          userGroupId,
          groupName,
          accessPermission,
          tenantId,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        });
        navigate('/user-groups');
      } catch (error) {
        setError('Error adding user group');
        setOpen(true);
      }
    };

  // Function to close the snackbar
  const handleCloseSnackbar = () => {
    setOpen(false); // Set snackbar open state to false
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column', // Stack children vertically
        alignItems: 'center',    // Center children horizontally
        justifyContent: 'center', // Center children vertically
        minHeight: '100vh',      // Full viewport height
        p: 2,                    // Padding
      }}
    >
      {/* Form title */}
      <Typography variant="h4" gutterBottom>
        Add User Group
      </Typography>
      <SideDrawer /> {/* Render the SideDrawer component */}
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '400px' }}>
        {/* Input for User Group ID */}
        <TextField
          label="User Group ID"
          fullWidth
          required
          margin="normal"
          value={userGroupId}
          onChange={(e) => setUserGroupId(e.target.value)} // Update state on change
        />
        {/* Input for Group Name */}
        <TextField
          label="Group Name"
          fullWidth
          required
          margin="normal"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)} // Update state on change
        />
        {/* Dropdown for selecting Access Permission */}
        <FormControl fullWidth margin="normal">
          <InputLabel>Access Permission</InputLabel>
          <Select
            value={accessPermission} // Current selected permission
            onChange={(e) => setAccessPermission(e.target.value)} // Update state on change
          >
            {/* Map through roles to create dropdown items */}
            {roles.map((role) => (
              <MenuItem key={role.value} value={role.value}>
                {role.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* Button to submit the form */}
        <Button type="submit" variant="contained" color="primary" fullWidth>
          Add User Group
        </Button>
      </form>
      {/* Snackbar for displaying error messages */}
      <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="error">
          {error} {/* Display the error message */}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddUserGroup; // Export the component
